import { Link } from 'react-router';
import { EmptyState } from '@/ui/EmptyState';

export function NotFoundPage() {
  return (
    <EmptyState title="Page not found" action={<Link to="/">Back to the dashboard</Link>}>
      There is nothing at this address.
    </EmptyState>
  );
}
